import { render } from "./GoalCardSkeleton.vue?vue&type=template&id=7ec1814a&scoped=true"
import script from "./GoalCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GoalCardSkeleton.vue?vue&type=script&lang=js"

import "./GoalCardSkeleton.vue?vue&type=style&index=0&id=7ec1814a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ec1814a"

export default script